import React, { useEffect, useRef, useState } from 'react';
import GradientBorder from '../../ui/GradientBorder';
import WhiteCard from '../../ui/WhiteCard';
import Loader from '../../ui/Loader';
import { useNavigate } from 'react-router-dom';
import EmptyArray from '../../ui/EmptyArray';
import { getAchievments } from '../../apis/geenpills/apis';
import { achievmentsData, allAchievementImages } from '../../constants/achievmentsData';
import { useLoadingState } from '../../hooks/useLoader';
import SelectedAchievmentModal from './SelectedAchievmentModal';

const Achievment = () => {
    const navigate = useNavigate();
    const dispatch = () => {};
    const scrollCards = useRef();
    const [selectedAchievment, setSelectedAchievment] = useState('');
    const greenPillNFTsHoldByWalletAddress = [];
    const [isModalOpen, setModalOpen] = useState(false);
    const [impactsAchieved, setImpactsAchieved] = useState({});
    const { loading, startLoading, stopLoading } = useLoadingState();

    useEffect(function () {
        const fetchData = async () => {
            try {
                startLoading();
                const data = await getAchievments();
                setImpactsAchieved(data);
            } catch (error) {
                console.log(error);
            } finally {
                stopLoading();
            }
        };
        fetchData();

        // return () => unsubscribe();
    }, []);
    const handleOpenModal = (achievmentId) => {
        setSelectedAchievment(achievmentId); // Set the selected bounty
        setModalOpen(true); // Open the modal
    };

    const handleCloseModal = () => {
        setModalOpen(false); // Close the modal
        setSelectedAchievment('');
    };
    console.log(impactsAchieved, 'impactsAchieved');

    const availableCards = allAchievementImages.filter((achievment) => {
        const card = { ...impactsAchieved[achievment?.type], keyType: achievment?.type };
        console.log(card);
        const isNotGradeOut = card[achievment?.key];

        return isNotGradeOut;
    });

    console.log(availableCards, 'selectedAchievment', selectedAchievment);

    return (
        <>
            <GradientBorder
                radiusBorder=".4rem"
                color1="rgba(84, 84, 84, 1)"
                color2="rgba(84, 84, 84, 0.38)"
                isNoBottomRadius={false}
                width="w-full"
                bg="bg-background"
                upperPadding="p-6"
                borderThickness="1px"
                className="mt-5"
            >
                <WhiteCard
                    bg={'bg-[#1D1D1D]'}
                    verticalMargin=""
                    ref={scrollCards}
                    className="p-4  flex items-center overflow-x-auto  gap-3  flex-nowrap   scrollableCards"
                >
                    {loading ? (
                        <p>loading...</p>
                    ) : (
                        allAchievementImages.map((achievment) => {
                            //  {
                            //     type: 'ISSUE_MONETARY_REWARD',
                            //     id: 'imr10000',
                            //     key: 10000,
                            //     image: monetaryRewards10000,
                            //     texts: {
                            //         first: 'Deployed $10,000 in Impact Funds',
                            //         second: '',
                            //     },
                            // },

                            const card = {
                                ...impactsAchieved[achievment?.type],
                                keyType: achievment?.type,
                                id: achievment?.id,
                            };

                            const isNotGradeOut = card[achievment?.key];
                            console.log(card, 'see the card');
                            return (
                                <div
                                    onClick={() => {
                                        if (isNotGradeOut) {
                                            console.log('clicked');
                                            handleOpenModal(card?.id);
                                        } else {
                                            return;
                                        }
                                    }}
                                    className={`bg-[#252525] rounded-lg p-3 flex flex-col gap-[.375rem]   `}
                                >
                                    <div
                                        key={achievment?.id}
                                        className="container cursor-pointer flex flex-col gap-[.375rem] rounded-lg w-[7.5rem]"
                                    >
                                        <div
                                            className={`w-[7.5rem] h-[10.5rem] rounded-lg overflow-hidden flex items-center justify-center  ${
                                                !isNotGradeOut ? 'opacity-50 grayscale cursor-not-allowed' : ''
                                            } `}
                                        >
                                            <img
                                                className="w-full h-full object-cover"
                                                src={achievment?.image}
                                                alt="greenpill-card"
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-xs text-center font-medium text-white">
                                            {achievment?.texts?.first}
                                        </p>
                                        <p className="text-xs text-center text-[#CFCFCF] font-medium mt-1">
                                            {achievment?.texts?.second}
                                        </p>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </WhiteCard>
            </GradientBorder>
            {isModalOpen && (
                <div>
                    <SelectedAchievmentModal
                        close={handleCloseModal}
                        selectedAchievment={selectedAchievment}
                        availableAchievments={availableCards}
                    />
                </div>
            )}
        </>
    );
};

export default Achievment;
